import { lazy } from 'react';

const CashAdvanceSetup = lazy(() =>
  import('../pages/CashAdvanceSubLedger/Setup.js').then((module) => ({
    default: module.CashAdvanceSetup,
  })),
);

const CashAdvanceOverride = lazy(() =>
  import('../pages/CashAdvanceSubLedger/Override.js').then((module) => ({
    default: module.CashAdvanceOverride,
  })),
);

const NonWorkingHolidays = lazy(() =>
  import('../pages/CashAdvanceSubLedger/NonWorkingHolidays.js'),
);

const CashAdvanceReport = lazy(() => import('../pages/CashAdvance/Report/'));

// const CashAdvanceOverride = lazy(() =>
//   import('../pages/CashAdvanceSubLedger/Override.js').then((module) => ({
//     default: module.CashAdvanceOverride,
//   })),
// );
// const CashAdvanceSubledgerEmployee = lazy(() =>
//   import('../pages/CashAdvanceSubLedger/Employee.js'),
// );
// const CashAdvanceSubledgerAll = lazy(() =>
//   import('../pages/CashAdvanceSubLedger/All.js'),
// );

const cashAdvanceRoute = {
  auth: [
    {
      name: 'cash_advance_setup',
      path: '/finance-and-accounting/cash-advance/setup',
      component: CashAdvanceSetup,
    },
    {
      name: 'cash_advance_override',
      path: '/finance-and-accounting/cash-advance/override',
      component: CashAdvanceOverride,
    },
    {
      name: 'cash_non_working_holidays',
      path: '/finance-and-accounting/cash-advance/non-working-holidays',
      component: NonWorkingHolidays,
    },
    {
      name: 'cash_advance_reports',
      path: '/finance-and-accounting/cash-advance/reports',
      component: CashAdvanceReport,
    },
    {
      name: 'cash_advance_reports',
      path: '/finance-and-accounting/cash-advance/reports',
      component: CashAdvanceReport,
    },
  ],
};

export default cashAdvanceRoute;
